import {
	COLORS,
	Checkbox,
	InfoTooltip,
} from '@monthio/react-components'
import {
	cloneElement,
	FunctionComponent,
	isValidElement,
	ReactNode,
	useState,
} from 'react'
import styled from 'styled-components'
import { ConditionalWrapper } from '../../shared/conditionalWrapper'
import { Conditionally } from '../../shared/conditionally'
import { BodyL, H3 } from '@monthio/design-system'

export const RowsWithHeadingContainer = styled.div`
	display: flex;
	flex-direction: column;
	background: ${COLORS.GREY_SCALE.WHITE};
	color: ${COLORS.TEXT_COLORS.DEFAULT};
	border-top-left-radius: 4px;
	border-top-right-radius: 4px;

	> * + * {
		border-top: 1px solid lightgrey;
	}

	input {
		font-size: 16px !important;
	}
`

const Container = styled.div<{ $isClickable?: boolean }>`
	display: flex;
	padding: 8px 12px;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	min-height: 40px;
	cursor: ${(props) => (props.$isClickable ? 'pointer' : '')};

	${H3} {
		margin: 0;
	}
`

const HeadingWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
`

const Subheading = styled(BodyL)`
	font-size: 12px;
`

const CheckboxWrapper = styled.div`
	.MuiFormControlLabel-root {
		margin-right: 0;
		padding: 0 0 0 8px;
	}
`
const LeftWrapper = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: left;
	gap: 8px;

	${(props) => props.theme.breakpoints.up('sm')} {
		gap: 8px;
	}
`

export const RowWithHeading: FunctionComponent<{
	heading: ReactNode
	subheading?: string
	tooltip?: ReactNode
	isSelected?: boolean
	onClick?: () => Promise<void>
	onSelect?: (isSelected: boolean) => void
}> = ({
	children,
	heading,
	subheading,
	tooltip,
	isSelected,
	onClick,
	onSelect,
}) => {
	const [isItemSelected, setItemIsSelected] = useState(isSelected ?? false)

	const handleContainerSelect = () => {
		setItemIsSelected(!isItemSelected)
		onSelect?.(!isItemSelected)
	}

	const wrappedChildren =
		!!onSelect && isValidElement(children) ? (
			<div onClick={(e) => e.stopPropagation()}>{cloneElement(children)}</div>
		) : (
			children
		)

	const handleHeadingClick = (event: any) => {
		!!onSelect ? event.stopPropagation() : null
	}

	return (
		<Container
			onClick={onClick ?? handleContainerSelect}
			$isClickable={!!onClick || !!onSelect}
		>
			<ConditionalWrapper
				condition={tooltip !== undefined}
				wrap={(children) => (
					<InfoTooltip tooltip={tooltip} modalTitle={heading} variant="helper">
						{children}
					</InfoTooltip>
				)}
			>
				<LeftWrapper>
					<Conditionally condition={onSelect !== undefined}>
						<CheckboxWrapper>
							<Checkbox checked={isItemSelected} color="primary" />
						</CheckboxWrapper>
					</Conditionally>
					<HeadingWrapper>
						<H3 onClick={handleHeadingClick}>{heading}</H3>
						{subheading != undefined ? (
							<Subheading>{subheading}</Subheading>
						) : null}
					</HeadingWrapper>
				</LeftWrapper>
			</ConditionalWrapper>
			{wrappedChildren}
		</Container>
	)
}
